var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c(
          "label",
          {
            staticStyle: {
              width: "100%",
              "text-align": "right",
              padding: "9px 0px",
              "font-size": "13px",
              "font-weight": "600",
            },
            attrs: { id: "labelColeta" },
          },
          [_vm._v(_vm._s(_vm.obterMensagemColeta()))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.PermitirColetar(),
                expression: "PermitirColetar()",
              },
            ],
            staticClass: "btn btn-block btn-primary",
            attrs: { id: "btnColetar", disabled: _vm.ColetaPendente() },
            on: {
              click: function ($event) {
                return _vm.novaColeta()
              },
            },
          },
          [_vm._v("Coletar")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dataComp,
                  expression: "dataComp",
                },
              ],
              staticClass: "aga-date datepicker form-control",
              attrs: {
                autocomplete: "off",
                "data-name": "Competencia",
                type: "text",
                "data-type": "date",
                "data-clear-btn": "true",
                maxlength: "7",
                placeholder: "mm/aaaa",
                "data-date-format": "mm/yyyy",
                "data-date-min-view-mode": "months",
                "data-date-start-view": "year",
                id: "inputCompetencia",
              },
              domProps: { value: _vm.dataComp },
              on: {
                change: function ($event) {
                  return _vm.competenciaChange($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.dataComp = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !this.dashInfo.existeColeta,
              expression: "!this.dashInfo.existeColeta",
            },
          ],
          staticStyle: {
            "font-size": "40px",
            position: "absolute",
            top: "50%",
            width: "80%",
            left: "12%",
            "z-index": "999",
            "text-align": "center",
          },
        },
        [_c("label", [_vm._v(_vm._s(_vm.obterMensagemSemColeta()))])]
      ),
      _vm._v(" "),
      _c("div", { style: _vm.desabilitar() }, [
        _c(
          "div",
          { staticClass: "col-md-6 col-lg-3" },
          [
            _c("ui-tile-dashboard-comercial", {
              attrs: {
                id: "NotasFiscais",
                title: "Notas fiscais",
                "color-title": "gray",
                "value-field": _vm.dashInfo.valueFieldNotasFiscais,
                percentage: _vm.dashInfo.percetageNotasFiscais,
                "color-value-field": " #2ab4c0 !important",
                "icon-main": "fa fa-database",
                "color-icon-main": "#2ab4c0",
                "color-icon-search": "gray",
                link: _vm.dashInfo.linkDetalhesFaturado,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 col-lg-3" },
          [
            _c("ui-tile-dashboard-comercial", {
              attrs: {
                id: "ValorFaturado",
                title: "Valor faturado",
                "color-title": "gray",
                "value-field": _vm.dashInfo.valueFieldFaturado,
                percentage: _vm.dashInfo.percetageFaturado,
                "color-value-field": " #5C9BD1 !important",
                "icon-main": "fa fa-bank",
                "color-icon-main": "#5C9BD1",
                "color-icon-search": "gray",
                "is-money": "",
                link: _vm.dashInfo.linkDetalhesFaturado,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 col-lg-3" },
          [
            _c("ui-tile-dashboard-comercial", {
              attrs: {
                id: "TicketMedio",
                title: "Ticket médio",
                "color-title": "gray",
                "value-field": _vm.dashInfo.valueFieldTicket,
                percentage: _vm.dashInfo.percetageTicket,
                "color-value-field": " #8877a9 !important",
                "icon-main": "fa fa-money",
                "color-icon-main": "#8877a9",
                "color-icon-search": "gray",
                "is-money": "",
                link: _vm.dashInfo.linkDetalhesFaturado,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-md-6 col-lg-3",
            attrs: { id: "appFaltaFaturar" },
          },
          [
            _c("ui-tile-dashboard-comercial", {
              ref: "faltaFaturar",
              attrs: {
                id: "FaltaFaturar",
                title: "Falta faturar",
                "color-title": "gray",
                "value-field": _vm.dashInfo.valueFieldFaltaFaturar,
                "color-value-field": "rgb(214, 77, 77)",
                "icon-main": "fa fa-calculator",
                "color-icon-main": "rgb(214, 77, 77)",
                "color-icon-search": "gray",
                "is-money": "",
                "visibility-perc": "hidden",
                link: _vm.dashInfo.linkDetalhesFaltaFaturar,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-btn" }, [
      _c(
        "button",
        { staticClass: "btn btn-default btn-sm", attrs: { type: "button" } },
        [_c("i", { staticClass: "fa fa-calendar" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "portlet solid bordered grey-cararra" }, [
        _c("div", { staticClass: "portlet-title" }, [
          _c("div", { staticClass: "caption" }, [
            _c("i", { staticClass: "fa fa-spin fa-cog" }),
            _vm._v("\n              Carregando...\n            "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body" }, [
          _c("div", {
            staticClass: "chart",
            staticStyle: {
              width: "100%",
              height: "400px",
              "background-color": "#FFFFFF",
            },
            attrs: { id: "grafico1" },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }